;(function () {
	'use strict'

	class CartBar extends HTMLElement {
		constructor() {
			super()

			this.productSection = this.closest('product-info')
			this.productForm = this.productSection.querySelector('[data-product-form]')
			this.formWrapper =
				(theme.settings.productPageSticky && this.productSection.querySelector('[data-form-wrapper]')) ||
				this.productForm

			this.handleProductAddError = this.handleProductAddError.bind(this)
			this.handleScroll = this.toggleCartBarOnScroll.bind(this)
			this.handleResize = this.setCartBarHeight.bind(this)
		}

		connectedCallback() {
			this.setCartBarHeight()
			this.addEventListener('click', this.handleClick.bind(this))
			document.addEventListener('theme:scroll', this.handleScroll)
			document.addEventListener('theme:resize', this.handleResize)
			document.addEventListener('theme:product:add-error', this.handleProductAddError)
		}

		handleClick(event) {
			const addToCartButton = event.target.closest('[data-cart-bar-add-to-cart]')

			if (addToCartButton) {
				event.preventDefault()

				addToCartButton.classList.add('is-loading')
				addToCartButton.setAttribute('disabled', 'disabled')

				const formAddToCartButton = this.productForm.querySelector('[data-add-to-cart]')

				formAddToCartButton.dispatchEvent(new Event('click', { bubbles: true }))

				document.dispatchEvent(
					new CustomEvent('theme:cart:add', {
						detail: {
							button: formAddToCartButton,
						},
						bubbles: true,
					})
				)

				console.log(formAddToCartButton)

				return
			}

			const scrollButton = event.target.closest('[data-cart-bar-scroll]')
			if (scrollButton) {
				event.preventDefault()
				this.scrollToProduct()
			}
		}

		handleProductAddError() {
			const addToCartButton = this.querySelector('[data-cart-bar-add-to-cart]')
			if (addToCartButton) {
				this.scrollToProduct()
			}
		}

		scrollToProduct() {
			const variantSelects = this.productSection.querySelector('variant-selects')
			const elementToScrollTo = window.theme.isMobile() ? variantSelects || this.productForm : this.productSection
			const topOffset = elementToScrollTo.getBoundingClientRect().top
			window.theme.scrollTo(window.theme.isMobile() ? topOffset - 10 : topOffset)
		}

		toggleCartBarOnScroll() {
			const scrollY = window.scrollY
			if (this.formWrapper) {
				const isBelowForm = scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight
				this.classList.toggle('is-visible', isBelowForm)
			}
		}

		setCartBarHeight() {
			const cartBarHeight = this.offsetHeight
			document.documentElement.style.setProperty('--cart-bar-height', `${cartBarHeight}px`)
		}

		disconnectedCallback() {
			document.removeEventListener('theme:product:add-error', this.handleProductAddError)
			document.removeEventListener('theme:scroll', this.handleScroll)
			document.removeEventListener('theme:resize', this.handleResize)
		}
	}

	if (!customElements.get('cart-bar')) {
		customElements.define('cart-bar', CartBar)
	}
})()

